
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/appointments/history",
      function () {
        return require("private-next-pages/user/appointments/history/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/appointments/history"])
      });
    }
  